// RAGE LOGGER (SPILL) PAGE
export const rageLoggerContent = {
  pageMaxWidth: '1200px',
  breadcrumb: {
    text: 'Back to Home',
    url: '/'
  },

  sections: [
    {
      id: 'hero',
      spacing: 'clamp(32px, 5vw, 64px)',
      blocks: [
        {
          type: 'container',
          narrow: true,
          blocks: [
            {
              type: 'custom',
              render: () => (
                <span style={{
                  background: 'linear-gradient(135deg, #ff00ff 0%, #00ffff 100%)',
                  color: '#1a1a1a',
                  padding: '8px 20px',
                  borderRadius: '25px',
                  fontSize: '13px',
                  fontWeight: '700',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  display: 'inline-block'
                }}>
                  Mobile Apps
                </span>
              )
            }
          ]
        },
        { type: 'spacer', size: 'small' },
        { type: 'title', text: 'SPILL (Rage Logger)', size: 'h1' },
        {
          type: 'text',
          content: 'Premium emotional expression and micro-journaling',
          size: 'large'
        },
        { type: 'spacer', size: 'small' },
        {
          type: 'text',
          content: 'A Gen-Z appealing app for emotional expression with animated rage sliders, vibe auras, glassmorphism UI, and a "Neon Noir Emotional Dump" aesthetic.'
        },
        { type: 'spacer', size: 'small' },
        {
          type: 'custom',
          render: () => (
            <span style={{
              background: 'linear-gradient(135deg, #ff00ff 0%, #00ffff 100%)',
              color: '#1a1a1a',
              padding: '12px 24px',
              borderRadius: '8px',
              fontWeight: '700'
            }}>
              In Development
            </span>
          )
        }
      ]
    },

    {
      id: 'philosophy',
      title: 'Design Philosophy',
      blocks: [
        {
          type: 'container',
          background: true,
          blocks: [
            {
              type: 'text',
              content: '"Neon Noir Emotional Dump" - A premium aesthetic that balances dark cyberpunk vibes with warm emotional release. The app feels like logging your emotions in a high-tech diary from 2045, but human and approachable.',
              size: 'large'
            }
          ]
        }
      ]
    },

    {
      id: 'features',
      title: 'Features',
      blocks: [
        {
          type: 'custom',
          render: () => (
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '24px'
            }}>
              {[
                { icon: '🎚️', title: 'Rage Slider', desc: 'Animated slider with color flood effects' },
                { icon: '✨', title: 'Vibe Aura', desc: 'Animated background reflecting emotional state' },
                { icon: '💎', title: 'Glassmorphism', desc: 'Modern frosted glass UI effects' },
                { icon: '🔥', title: 'Streak System', desc: 'Gentle daily logging streaks' },
                { icon: '📳', title: 'Haptic Feedback', desc: 'Contextual haptics based on rage intensity' },
                { icon: '🎨', title: 'Theme System', desc: 'Dark, Light, and Rage modes' }
              ].map((feature, i) => (
                <div key={i} style={{
                  background: 'var(--bg-secondary)',
                  padding: '24px',
                  borderRadius: '16px',
                  border: '1px solid var(--border-color)'
                }}>
                  <div style={{ fontSize: '2rem', marginBottom: '12px' }}>{feature.icon}</div>
                  <h3 style={{ color: 'var(--text-primary)', marginBottom: '8px', fontSize: '1.1rem' }}>{feature.title}</h3>
                  <p style={{ color: 'var(--text-secondary)', fontSize: '0.95rem', margin: 0 }}>{feature.desc}</p>
                </div>
              ))}
            </div>
          )
        }
      ]
    },

    {
      id: 'tech',
      title: 'Built With',
      blocks: [
        {
          type: 'custom',
          render: () => (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
              {['React Native', 'Expo', 'Framer Motion', 'Haptics API', 'Glassmorphism'].map((tech, i) => (
                <span key={i} style={{
                  background: 'var(--bg-secondary)',
                  color: 'var(--text-primary)',
                  padding: '10px 20px',
                  borderRadius: '25px',
                  fontSize: '0.9rem',
                  border: '1px solid var(--border-color)'
                }}>{tech}</span>
              ))}
            </div>
          )
        }
      ]
    }
  ],

  callToAction: {
    title: 'SPILL',
    text: 'Express yourself, no filter needed',
    button: { text: 'See more work →', url: '/' }
  }
};
